module.exports = "/fonts/fa-regular-400.eot?b58f468f84168d61e0ebc1e1f423587c";